import { useEffect, useMemo, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { PenyelSheet, PENYEL_CSS, paginateRecords } from "../components/PenyelSheets";

export default function JanaPenyelenggaraanPrint() {
  const { vehicleId } = useParams();
  const [params] = useSearchParams();
  const year = Number(params.get("year")) || new Date().getFullYear();
  const month = params.get("month") ? Number(params.get("month")) : null;
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get(`/reports/penyelenggaraan/${vehicleId}`, { params: { year, ...(month && { month }) } })
      .then((r) => setData(r.data))
      .catch(() => setErr("Gagal memuatkan data laporan."));
  }, [vehicleId, year, month]);

  const pages = useMemo(() => (data ? paginateRecords(data.records) : []), [data]);

  if (err) return <div style={{ padding: 40, fontFamily: "Arial" }}>{err}</div>;
  if (!data) return <div style={{ padding: 40, fontFamily: "Arial" }}>Menjana laporan...</div>;

  return (
    <div className="penyel-doc" style={{ background: "#525659", minHeight: "100vh" }} data-testid="penyel-print-page">
      <style>{PENYEL_CSS}</style>
      <style>{`
        .penyel-doc .sheet { margin: 12px auto; }
        .jl-print-btn { position: fixed; top: 14px; right: 18px; z-index: 50; background: #10056E; color: #fff; border: 0; border-radius: 8px; padding: 10px 18px; font-size: 13px; font-weight: 600; cursor: pointer; box-shadow: 0 4px 14px rgba(0,0,0,.35); }
        @page { size: A4 landscape; margin: 0; }
        @media print {
          .penyel-doc { background: #fff !important; }
          .jl-print-btn { display: none; }
          .penyel-doc .sheet { margin: 0; page-break-after: always; height: 210mm; box-shadow: none; }
        }
      `}</style>
      <button className="jl-print-btn" onClick={() => window.print()} data-testid="penyel-print-btn">
        Cetak / Simpan PDF
      </button>
      {pages.map((rows, i) => (
        <PenyelSheet key={i} data={data} rows={rows} footer={`M.S. ${i + 1}/${pages.length}`} />
      ))}
    </div>
  );
}
